<dx-scroll-view id="scrollview">
    <div class="global" style="margin:8px">
        <div class="flex home">
            <div id="history-file-transfers" class="home-history-file-transfers">
                <app-home-history-file-transfers></app-home-history-file-transfers>
            </div>
            <div id="statistics">
                <app-home-statistics></app-home-statistics>
            </div>
            <div id="file-transfers-execution">
                <app-home-file-transfers-execution></app-home-file-transfers-execution>
            </div>
            <div id="local-agents-management">
                <app-home-local-agents-management></app-home-local-agents-management>
            </div>
            <div id="ack-waiting-list">
                <app-home-ack-waiting-list></app-home-ack-waiting-list>
            </div>
            <!--<div style="float:left;width:100%;">
                <app-home-platforms-relations></app-home-platforms-relations>
            </div>-->
        </div>
    </div>
</dx-scroll-view>
